module.exports = __webpack_public_path__ + "img/thumb_11.cf3c6de8.jpg";